<div class="card pull-up">
  <div class="card-content" >
    <div class="card-body">
      <div class="media d-flex">
        <div class="media-body text-left">
          <h3 [ngClass]="datos[0].color">{{datos[0].value}}</h3>
          <span>{{datos[0].text}}</span>
        </div>
        <div class="align-self-center">
          <i class="font-large-2 float-right {{ datos[0].icon }}" [ngClass]="datos[0].color"></i>
        </div>
      </div>
      @if (datos[0].progress) {
        <div class="progress mt-1 mb-0" style="height: 7px;">
          <div
            class="progress-bar bg-{{ datos[0].color }}"
            role="progressbar"
            style="width: 80%"
            aria-valuenow="80"
            aria-valuemin="0"
            aria-valuemax="100">
          </div>
        </div>
      }
    </div>
  </div>
</div>